import { z } from 'zod';

export const Age = z.number().min(0);

export type Age = z.infer<typeof Age>;
